<template>
  <div class="flex flex-col justify-between flex-grow h-full gap-2">
    <div
      class="flex flex-col items-center content-center justify-center flex-grow-0 h-full transition-all gap-x-3"
      :class="{ 'gap-y-4': !isCollapsed, 'gap-y-2': isCollapsed }"
    >
      <div class="grid items-center grid-cols-5">
        <BlTextTitle2
          :text="timer.split(':')[0]"
          class="flex justify-center transition-all duration-300"
          :class="[isStarted ? 'text-slate-800' : 'text-slate-600']"
        />
        <BlTextTitle2
          text=":"
          class="flex justify-center pb-2 transition-all duration-300"
          :class="[isStarted ? 'text-slate-800' : 'text-slate-600']"
        />
        <BlTextTitle2
          :text="timer.split(':')[1]"
          class="flex justify-center transition-all duration-300"
          :class="[isStarted ? 'text-slate-800' : 'text-slate-600']"
        />
        <BlTextTitle2
          text=":"
          class="flex justify-center pb-2 transition-all duration-300"
          :class="[isStarted ? 'text-slate-800' : 'text-slate-600']"
        />
        <BlTextTitle2
          :text="timer.split(':')[2]"
          class="flex justify-center transition-all duration-300"
          :class="[isStarted ? 'text-slate-800' : 'text-slate-600']"
        />
      </div>
      <BlInputButton
        :label="isStarted ? 'Stop timer' : 'Start timer'"
        :loading="updateLoading"
        class="w-full rounded-3xl"
        :class="{ 'pointer-events-none': sessionStatus !== 'ongoing' }"
        @clicked="$emit('toggle-timer')"
      />
    </div>

    <div v-if="!isCollapsed" class="flex-shrink-0 pb-3 text-center">
      <BlTextBody2 text="Goal:" />
      <BlTextBody2
        v-if="
          measurement.target.success_metric === 'equal to or greater than goal'
        "
        text="≥"
      />
      <BlTextBody2
        v-if="measurement.target.success_metric === 'less than goal'"
        text="<"
      />
      <BlTextBody2 :text="measurement.target.goal_time" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import BlTextTitle2 from "../../BlTextTitle2.vue";
import BlTextBody2 from "../../BlTextBody2.vue";
import BlInputButton from "../../BlInputButton.vue";

export default {
  name: "MeasurementCardDuration",
  components: {
    BlTextTitle2,
    BlTextBody2,
    BlInputButton
  },
  props: {
    measurement: { type: Object, required: true },
    sessionStatus: { type: String, required: true },
    isStarted: { type: Boolean, required: true },
    timer: { type: String, required: true },
    updateLoading: { type: Boolean, required: true },
    isCollapsed: { type: Boolean, default: false }
    // @toggle-timer
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["viewMode"])
  },
  mounted() {},
  methods: {}
};
</script>



// WEBPACK FOOTER //
// src/components/sessions/card/Duration.vue